export const Loading = () => <p>A carregar lista</p>;
